import { render } from "./SpotTitle.vue?vue&type=template&id=d04cfd3c&scoped=true"
import script from "./SpotTitle.vue?vue&type=script&lang=js"
export * from "./SpotTitle.vue?vue&type=script&lang=js"

import "./SpotTitle.vue?vue&type=style&index=0&id=d04cfd3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d04cfd3c"]])

export default __exports__